import React from "react";
export default ({ className = "" }: { className?: string }) => {
  return (
    <footer className={className}>
      © Copyright 2013-{new Date().getFullYear()} Rich Soni LLC. All Rights
      Reserved.
    </footer>
  );
};
